import { render, staticRenderFns } from "./quiz-campaign.vue?vue&type=template&id=3e0fa252&scoped=true&"
import script from "./quiz-campaign.vue?vue&type=script&lang=js&"
export * from "./quiz-campaign.vue?vue&type=script&lang=js&"
import style0 from "./quiz-campaign.vue?vue&type=style&index=0&id=3e0fa252&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0fa252",
  null
  
)

export default component.exports